import { IconProps } from '@chakra-ui/react';
import { FreightService } from '@pelicargo/types';

import { AirlineIcon } from './AirlineIcon';
import { TruckIcon } from './TruckIcon';

type Props = IconProps & {
  freightService?: FreightService;
};

export const FreightServiceIcon = ({ freightService, ...props }: Props) => {
  if (freightService === FreightService.EXW || freightService === FreightService.FCA) {
    return <TruckIcon {...props} />;
  }

  return <AirlineIcon {...props} />;
};
